// 共用客戶編輯器 (客戶資料庫頁 + 報價單即場新增都用)
import React, { useState } from 'react';
import { api } from './api.js';
import { Modal, Field, useToast } from './ui.jsx';

export default function CustomerEditor({ initial, onSaved, onClose }) {
  const { toast } = useToast();
  const isNew = !initial?.id;
  const [f, setF] = useState({
    code: initial?.code || '', name: initial?.name || '', contact: initial?.contact || '',
    phone: initial?.phone || '', email: initial?.email || '', tax_id: initial?.tax_id || '',
    office_address: initial?.office_address || '', notes: initial?.notes || '',
  });
  const [addrs, setAddrs] = useState(() => {
    const list = initial?.addresses;
    if (list && list.length) return list.map(a => ({ ...a }));
    return [{ label: '', address: '', is_default: true }]; // 空嘅都顯示一行方便輸入
  });
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const setAddr = (i, k, v) => setAddrs(list => list.map((a, x) => x === i ? { ...a, [k]: v } : a));
  const save = async () => {
    if (!f.name.trim()) return toast('請填寫客戶名稱', 'err');
    const body = { ...f, addresses: addrs.filter(a => a.address.trim()) };
    try {
      if (isNew) { const r = await api.post('/customers', body); toast('客戶已建立 ✔'); onSaved(r.id); }
      else { await api.put(`/customers/${initial.id}`, body); toast('客戶已更新 ✔'); onSaved(initial.id); }
    } catch (e) { toast(e.message, 'err'); }
  };
  return (
    <Modal size="lg" onClose={onClose} icon="🏢" title={isNew ? '➕ 新增客戶' : `✏️ 編輯客戶 — ${initial.name}`}
      footer={<>
        <button className="btn" onClick={onClose}>取消</button>
        <button className="btn primary" onClick={save}>💾 儲存</button>
      </>}>
      <div className="form-grid mb">
        <Field label="客戶編號"><input className="input" value={f.code} onChange={e => set('code', e.target.value)} placeholder="自動產生" /></Field>
        <Field label="公司名稱" required><input className="input" value={f.name} onChange={e => set('name', e.target.value)} /></Field>
        <Field label="聯絡人"><input className="input" value={f.contact} onChange={e => set('contact', e.target.value)} /></Field>
        <Field label="電話"><input className="input" value={f.phone} onChange={e => set('phone', e.target.value)} /></Field>
        <Field label="Email"><input className="input" value={f.email} onChange={e => set('email', e.target.value)} /></Field>
        <Field label="商業登記號"><input className="input" value={f.tax_id} onChange={e => set('tax_id', e.target.value)} /></Field>
        <Field label="Office 地址 (通訊/帳單地址 — 印喺報價/發票)" span2><input className="input" value={f.office_address} onChange={e => set('office_address', e.target.value)} placeholder="客戶寫字樓地址 (唔係地盤地址)" /></Field>
        <Field label="備註" span2><textarea className="textarea" value={f.notes} onChange={e => set('notes', e.target.value)} placeholder="內部備註 (例如付款習慣、特別要求)" /></Field>
      </div>
      <div className="card-title" style={{ marginTop: 4 }}><span className="ico-badge sky" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>📍</span>
        地址清單 (每個客可有多個地址 — 地盤/寫字樓等)
        <span className="spacer" />
        <button className="btn sm" onClick={() => setAddrs(l => [...l, { label: '', address: '', is_default: false }])}>➕ 地址</button>
      </div>
      {addrs.map((a, i) => (
        <div key={i} className="row mb" style={{ alignItems: 'flex-start', background: 'var(--surface-soft)', padding: 12, borderRadius: 13, border: '1px solid var(--line)' }}>
          <div style={{ flex: '0 0 170px' }}>
            <input className="input" placeholder="標籤 (例如: 地盤A)" value={a.label} onChange={e => setAddr(i, 'label', e.target.value)} />
          </div>
          <div style={{ flex: 1 }}>
            <input className="input" placeholder="完整地址" value={a.address} onChange={e => setAddr(i, 'address', e.target.value)} />
          </div>
          <label className="row" style={{ gap: 5, fontSize: 12.5, fontWeight: 700, color: 'var(--ink-2)', paddingTop: 9 }}>
            <input type="radio" name={'def-addr-' + (initial?.id || 'new')} checked={!!a.is_default} onChange={() => setAddrs(l => l.map((x, xi) => ({ ...x, is_default: xi === i })))} /> 預設
          </label>
          <button className="btn sm coral" onClick={() => setAddrs(l => l.filter((_, x) => x !== i))}>✕</button>
        </div>
      ))}
    </Modal>
  );
}
